"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var actions_1 = require("../store/animation-playing/actions");
var CoinAnimation = (function () {
    function CoinAnimation(assets, store) {
        this.coinInAssets = assets.coinIn;
        this.coinOutOneAssets = assets.coinOut1;
        this.coinOutTwoAssets = assets.coinOut2;
        this.shine1 = assets.shine1;
        this.shine2 = assets.shine2;
        this.coinInframe = 0;
        this.coinInDouble = 0;
        this.coinOutDouble = 0;
        this.coinOutDoubleTwo = 0;
        this.shineOneDouble = 0;
        this.shineTwoDouble = 0;
        this.coinOutOneFrame = 0;
        this.coinOutTwoFrame = 0;
        this.shine1Frame = 0;
        this.shine2Frame = 0;
        this.store = store;
    }
    CoinAnimation.prototype.animateCoinIn = function (canvasElement, winNumber, id) {
        var _this = this;
        if (canvasElement.getElement()) {
            var ctx_1 = canvasElement.getElement().getContext('2d');
            if (ctx_1) {
                ctx_1.clearRect(0, 0, canvasElement.getElement().width, canvasElement.getElement().height);
                ctx_1.drawImage(this.coinInAssets[this.coinInframe], 30, -40, canvasElement.width(80), canvasElement.height(150));
            }
            if (this.coinInframe !== 25) {
                if (this.coinInDouble === 2) {
                    this.coinInframe++;
                }
                this.coinInDouble++;
                if (this.coinInDouble > 2) {
                    this.coinInDouble = 0;
                }
                window.requestAnimationFrame(function () { return _this.animateCoinIn(canvasElement, winNumber, id); });
            }
            else {
                this.coinInframe = 0;
                switch (winNumber) {
                    case 1:
                        window.requestAnimationFrame(function () { return _this.animateCoinOutOne(canvasElement, ctx_1, id); });
                        break;
                    case 2:
                        window.requestAnimationFrame(function () { return _this.animateCoinOutTwo(canvasElement, ctx_1, id); });
                        break;
                    default:
                        return;
                }
            }
        }
    };
    CoinAnimation.prototype.animateCoinOutOne = function (canvasElement, ctx, id) {
        var _this = this;
        if (ctx) {
            ctx.clearRect(0, 0, canvasElement.getElement().width, canvasElement.getElement().height);
            ctx.drawImage(this.coinOutOneAssets[this.coinOutOneFrame], 30, -40, canvasElement.width(80), canvasElement.height(150));
        }
        if (this.coinOutOneFrame !== 9) {
            if (this.coinOutDouble === 2) {
                this.coinOutOneFrame++;
            }
            this.coinOutDouble++;
            if (this.coinOutDouble > 2) {
                this.coinOutDouble = 0;
            }
            window.requestAnimationFrame(function () { return _this.animateCoinOutOne(canvasElement, ctx, id); });
        }
        else {
            window.requestAnimationFrame(function () { return _this.animateShine1(canvasElement, ctx, id); });
            this.coinOutOneFrame = 0;
            return;
        }
    };
    CoinAnimation.prototype.animateCoinOutTwo = function (canvasElement, ctx, id) {
        var _this = this;
        if (ctx) {
            ctx.clearRect(0, 0, canvasElement.getElement().width, canvasElement.getElement().height);
            ctx.drawImage(this.coinOutTwoAssets[this.coinOutTwoFrame], 30, -40, canvasElement.width(80), canvasElement.height(150));
        }
        if (this.coinOutTwoFrame !== 9) {
            if (this.coinOutDoubleTwo === 2) {
                this.coinOutTwoFrame++;
            }
            this.coinOutDoubleTwo++;
            if (this.coinOutDoubleTwo > 2) {
                this.coinOutDoubleTwo = 0;
            }
            window.requestAnimationFrame(function () { return _this.animateCoinOutTwo(canvasElement, ctx, id); });
        }
        else {
            window.requestAnimationFrame(function () { return _this.animateShine2(canvasElement, ctx, id); });
            this.coinOutTwoFrame = 0;
            return;
        }
    };
    CoinAnimation.prototype.animateShine1 = function (canvasElement, ctx, id) {
        var _this = this;
        if (ctx) {
            ctx.clearRect(0, 0, canvasElement.getElement().width, canvasElement.getElement().height);
            ctx.drawImage(this.shine1[this.shine1Frame], 30, -40, canvasElement.width(80), canvasElement.height(150));
        }
        if (this.shine1Frame !== 30) {
            if (this.shineOneDouble === 1) {
                this.shine1Frame++;
            }
            this.shineOneDouble++;
            if (this.shineOneDouble > 1) {
                this.shineOneDouble = 0;
            }
            window.requestAnimationFrame(function () { return _this.animateShine1(canvasElement, ctx, id); });
        }
        else {
            var test = null;
            document.getElementsByClassName("coins-card-id-" + id) ?
                test = document.getElementsByClassName("coins-card-id-" + id)[0] : '';
            test ? test.querySelector('.coins-body-left') ? test.querySelector('.coins-body-left')
                .classList.add('my-glower', 'no-animation') : '' : '';
            this.store.dispatch(actions_1.resetPlayAnimation());
            this.shine1Frame = 0;
            return;
        }
    };
    CoinAnimation.prototype.animateShine2 = function (canvasElement, ctx, id) {
        var _this = this;
        if (ctx) {
            ctx.clearRect(0, 0, canvasElement.getElement().width, canvasElement.getElement().height);
            ctx.drawImage(this.shine2[this.shine2Frame], 30, -40, canvasElement.width(80), canvasElement.height(150));
        }
        if (this.shine2Frame !== 30) {
            if (this.shineTwoDouble === 1) {
                this.shine2Frame++;
            }
            this.shineTwoDouble++;
            if (this.shineTwoDouble > 1) {
                this.shineTwoDouble = 0;
            }
            window.requestAnimationFrame(function () { return _this.animateShine2(canvasElement, ctx, id); });
        }
        else {
            var test = null;
            document.getElementsByClassName("coins-card-id-" + id) ?
                test = document.getElementsByClassName("coins-card-id-" + id)[0] : '';
            test ? test.querySelector('.coins-body-right') ? test.querySelector('.coins-body-right')
                .classList.add('my-glower', 'no-animation') : '' : '';
            this.store.dispatch(actions_1.resetPlayAnimation());
            this.shine2Frame = 0;
            return;
        }
    };
    return CoinAnimation;
}());
exports.default = CoinAnimation;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/coin-animation/coin-animation.ts
// module id = 1998
// module chunks = 4